export enum MainDealersQueryKeys {
  All = "allMainDealers",
  MainDealer = "mainDealer",
  Transactions = "transactions",
}
